import axios from "axios";

const instance = axios.create({
  baseURL: "https://treasure-hunt-f087e.firebaseio.com",
});

export default instance;
